export * from './PrintoutModule'
export const printoutsPath = '/et/company/:companyId/printoutsModule'
